import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ReactiveFormsModule } from '@angular/forms';
import { TokenService } from '~services/token.service';
import { combineLatest, EMPTY, iif, Observable, Subscription, switchMap } from 'rxjs';
import { UserService } from '~services/user.service';
import { IUser } from '~models/interfaces/user.interface';
import { MediaplanCheckService } from '~services/mediaplan-check.service';
import { MatDialog } from '@angular/material/dialog';
import { MediaplanStatusDialogComponent } from '~components/dialogs/mediaplan-status-dialog/mediaplan-status-dialog.component';

@Component({
	selector: 'led-root',
	standalone: true,
	imports: [RouterOutlet, MatSidenavModule, ReactiveFormsModule],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
	private tokenService = inject(TokenService);

	private userService = inject(UserService);

	private mediaplanCheckService = inject(MediaplanCheckService);

	private dialog = inject(MatDialog);

	private subs = new Subscription();

	private dialogIsOpen = false;

	public ngOnInit(): void {
		this.subs.add(
			this.tokenService
				.initTokens()
				.pipe(switchMap((hasTokens) => iif(() => hasTokens, this.initUserData(), EMPTY)))
				.subscribe()
		);

		this.subs.add(this.mediaplanCheckService.getWatchTrigger().subscribe(() => this.openMediaplanStatusDialog()));
	}

	public ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	private initUserData(): Observable<[IUser, string[]]> {
		return combineLatest([this.userService.me(), this.userService.loadPrivileges()]);
	}

	private openMediaplanStatusDialog(): void {
		if (this.dialogIsOpen) return;
		this.dialogIsOpen = true;

		const dialogRef = this.dialog.open(MediaplanStatusDialogComponent, {
			width: '700px',
			maxWidth: '95vw',
			maxHeight: '90vh',
			disableClose: false,
			autoFocus: false,
			data: {
				title: 'Обновление медиаплана',
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			this.dialogIsOpen = false;
		});
	}
}
